import {
  useEffect,
  useMemo,
} from 'react';

const useDefaultPaymentMethod = (
  inputFieldName,
  defaultPaymentMethods,
  paymentMethod,
  handleUpdateForm,
  paymentCode = '10',
  origin = ''
) => {
  const defaultPaymentMethodId = useMemo(() => {
    if (
      Array.isArray(defaultPaymentMethods) &&
      defaultPaymentMethods?.length > 0
    ) {
      const defaultPay = defaultPaymentMethods.find(
        (p) => p.codigo === paymentCode
      );

      if (paymentMethod === '' && defaultPay) {
        return defaultPay.id;
      }
    }
    return null;
    // eslint-disable-next-line
  }, [defaultPaymentMethods]);

  useEffect(() => {
    if (
      defaultPaymentMethodId &&
      (paymentMethod === '' || paymentMethod === undefined)
    ) {
      const updateData = {
        [inputFieldName]: defaultPaymentMethodId,
      };

      handleUpdateForm(updateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPaymentMethodId, handleUpdateForm, origin]);

  return defaultPaymentMethodId;
};

export default useDefaultPaymentMethod;
